import React, { Component } from 'react';
import moment from 'moment';

import ParkinglocationSettingsForm from './ParkinglocationSettingsForm';
import ParkinglocationPriorityMsgForm from './ParkinglocationPriorityMsgForm';
import { defaultSorter, dateSorter } from './Helpers';
import ParkinglocationModel from './ParkinglocationModel';
import UserModel from './UserModel';

import { Table, Popconfirm, Divider, Typography, Tooltip, message, Badge } from 'antd';

class ParkinglocationTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    parkinglocationSettingsFormData: null,
    parkinglocationPriorMsgFormData: null,
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }
  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Kód',
      dataIndex: 'Code',
      key: 'Code',
      width: 150,
      sorter: (a, b) => defaultSorter(a.Code, b.Code),
      defaultSortOrder: 'ascend',
      render: (text, rec) => {
        return <Tooltip placement="right" title={rec.id}>{text}</Tooltip>
      },
    }, {
      title: 'Název',
      dataIndex: 'Name',
      key: 'Name',
      sorter: (a, b) => defaultSorter(a.Name, b.Name),
      defaultSortOrder: 'ascend',
    }, {
      title: 'Kapacita',
      dataIndex: 'Capacity',
      key: 'Capacity',
      width: 100,
    }, {
      title: 'Obsazeno',
      dataIndex: 'TotalOcc',
      key: 'TotalOcc',
      width: 100,
    }, {
      title: 'Volno',
      dataIndex: 'Capacity-TotalOcc',
      key: 'Capacity-TotalOcc',
      width: 100,
      render: (text, record) => {
        return (record.Capacity - record.TotalOcc > 0) ? record.Capacity - record.TotalOcc : 0;
      }
    }, {
      title: 'Čas poslední změny',
      dataIndex: 'LastChanges',
      key: 'LastChanges',
      width: 200,
      render: (text, record) => {
        if (text !== undefined) {
          return moment(text).format('L LTS');
        }
      }
    }, {
      title: 'Prioritní zpráva',
      dataIndex: 'PriorityMessage',
      key: 'PriorityMessage',
      width: 100,
      render: (text, record) => {
        let now = moment().toISOString();
        if (record.PriorityMessage && record.PriorityMsgFrom && record.PriorityMsgTo && moment(record.PriorityMsgFrom).isSameOrBefore(now) && moment(record.PriorityMsgTo).isSameOrAfter(now)) {
          return (
            <Tooltip title='Je aktivní'>
              <Badge
                status="success" />
            </Tooltip>
          )
        } else {
          return (
            <Tooltip title='Není aktivní' >
              <Badge
                status="error" />
            </Tooltip>
          )
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 350,
      render: (text, record) => {
        return (
          <React.Fragment>
            {
              UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_SET_PRIOR_MSG']) && (
                <React.Fragment>
                  <a onClick={(e) => {
                    this.setState({
                      parkinglocationPriorMsgFormData: record
                    });
                  }}>Prioritní zpráva</a>
                  <Divider type="vertical" />
                </React.Fragment>
              )
            }
            {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE']) && (
              <React.Fragment>
                <a onClick={(e) => {
                  this.props.onDetailRow
                    ? this.props.onDetailRow(record)
                    : null;
                }}>Detail</a>
                <Divider type="vertical" />
                <a onClick={(e) => {
                  this.setState({
                    parkinglocationSettingsFormData: record
                  });
                }}>Nastavení</a>
                <Divider type="vertical" />
                <Popconfirm
                  placement="right"
                  title="Opravdu si přejete záznam smazat?"
                  onConfirm={() => {
                    this.props.onRemoveRow
                      ? this.props.onRemoveRow(record.id)
                      : null;
                  }}
                  okText="Ano"
                  cancelText="Ne"
                >
                  <a onClick={(e) => { e.preventDefault(); }}>
                    <Typography.Text type="danger">Smazat</Typography.Text>
                  </a>
                </Popconfirm>
              </React.Fragment>
            )
            }
          </React.Fragment>
        )
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          onChange={this.handleChange}
          dataSource={this.props.data}
          style={{ border: '0px' }} />
        <ParkinglocationSettingsForm
          type="modal"
          modalVisible={this.state.parkinglocationSettingsFormData === null ? false : true}
          initialValues={this.state.parkinglocationSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ parkinglocationSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            ParkinglocationModel.patch(this.state.parkinglocationSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  parkinglocationSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
        <ParkinglocationPriorityMsgForm
          type="modal"
          modalVisible={this.state.parkinglocationPriorMsgFormData === null ? false : true}
          initialValues={this.state.parkinglocationPriorMsgFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ parkinglocationPriorMsgFormData: null });
          }}
          onSuccess={(form, values) => {
            ParkinglocationModel.patch(this.state.parkinglocationPriorMsgFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  parkinglocationPriorMsgFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default ParkinglocationTable;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationTable.js